import { render, staticRenderFns } from "./FlashCards.vue?vue&type=template&id=3e97fe08&"
import script from "./FlashCards.vue?vue&type=script&lang=js&"
export * from "./FlashCards.vue?vue&type=script&lang=js&"
import style0 from "./FlashCards.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports